import React from 'react'
import styled from 'styled-components/macro'
import { shouldShowHarbourMyWork } from 'src/utils/harbourBoard'
import HarbourMyWork from './HarbourMyWork'
import HarbourNeedsYou from './HarbourNeedsYou'

/**
 * Work management board: capped Needs you + claimed My work columns.
 * Not the venue estate. No pagination of at-risk.
 */
const HarbourBoard = ({
  needsYouCards = [],
  needsYou = {},
  thriving = {},
  askSales = {},
  showThriving = false,
  needsYouLoading = false,
  needsYouError = null,
  workColumns = {},
  workLoading = false,
  workError = null,
  ownerFilter,
  hideParked = true,
  now,
  startBusyVenueId = null,
  onRetryNeedsYou,
  onRetryWork,
  onSelectVenue,
  onStartWork,
  onAskSales,
  onAskProduct,
  onToggleThriving,
}) => {
  const showMyWork = shouldShowHarbourMyWork(ownerFilter)

  return (
    <Board data-testid='harbour-board' $showMyWork={showMyWork}>
      <HarbourNeedsYou
        cards={needsYouCards}
        needsYou={needsYou}
        thriving={thriving}
        askSales={askSales}
        showThriving={showThriving}
        loading={needsYouLoading}
        error={needsYouError}
        now={now}
        startBusyVenueId={startBusyVenueId}
        onRetry={onRetryNeedsYou}
        onSelectVenue={onSelectVenue}
        onStartWork={onStartWork}
        onAskSales={onAskSales}
        onAskProduct={onAskProduct}
        onToggleThriving={onToggleThriving}
      />
      {showMyWork ? (
        <HarbourMyWork
          columns={workColumns}
          hideParked={hideParked}
          ownerFilter={ownerFilter}
          loading={workLoading}
          error={workError}
          now={now}
          startBusyVenueId={startBusyVenueId}
          onRetry={onRetryWork}
          onSelectVenue={onSelectVenue}
          onStartWork={onStartWork}
          onAskSales={onAskSales}
          onAskProduct={onAskProduct}
        />
      ) : null}
    </Board>
  )
}

const Board = styled.div`
  display: grid;
  grid-template-columns: ${({ $showMyWork }) =>
    $showMyWork
      ? 'minmax(16.5rem, 0.9fr) minmax(0, 3fr)'
      : 'minmax(16.5rem, 22rem)'};
  gap: ${({ theme }) => theme.spacing.md || '16px'};
  align-items: start;
  overflow-x: auto;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export default HarbourBoard
